import { render, staticRenderFns } from "./login-loader.vue?vue&type=template&id=6ebec15c"
import script from "./login-loader.vue?vue&type=script&lang=js"
export * from "./login-loader.vue?vue&type=script&lang=js"
import style0 from "./login-loader.vue?vue&type=style&index=0&id=6ebec15c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./login-loader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports